import React, { useState } from "react";
import "./pages.scss";
import SkillsChart from "./ProjectsSections/SkillsChart";
import Team from "../Images/team.png";
import Ecommerce from "../Images/ecommerce.png";
import Datavis from "../Images/datavis.png";
import Calculator from "../Images/calculator.png";
import Todolist from "../Images/todolist.png";
import Teampage from "../Images/teampage.png";
import Backend from "../Images/backend.png";
import UC from "../Images/uc.png"
import Pop1 from "../Images/Dataimg.png";
import Pop2 from "../Images/Teamimg.png";
import Pop3 from "../Images/Calc.png";
import Pop4 from "../Images/ecommerceimg.png";
import Pop5 from "../Images/Calc.png";
import Pop6 from "../Images/TeampageImg.png";
import Pop7 from "../Images/Calc.png";
import ProjectEffect from "./projecteffect/projectEffect";
export default function Projects() {
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  const [showPopUp3, setShowPopUp3] = useState(false);
  const [showPopUp4, setShowPopUp4] = useState(false);
  const [showPopUp5, setShowPopUp5] = useState(false);
  const [showPopUp6, setShowPopUp6] = useState(false);
  const [showPopUp7, setShowPopUp7] = useState(false);
  const handleButtonClick1 = () => {
    setShowPopUp1(!showPopUp1);
  };
  const handleButtonClick2 = () => {
    setShowPopUp2(!showPopUp2);
  };
  const handleButtonClick3 = () => {
    setShowPopUp3(!showPopUp3);
  };
  const handleButtonClick4 = () => {
    setShowPopUp4(!showPopUp4);
  };
  const handleButtonClick5 = () => {
    setShowPopUp5(!showPopUp5);
  };
  const handleButtonClick6 = () => {
    setShowPopUp6(!showPopUp6);
  };
  const handleButtonClick7 = () => {
    setShowPopUp7(!showPopUp7);
  };

  const handleClose = () => {
    if (showPopUp1 === true) setShowPopUp1(!showPopUp1);
    if (showPopUp2 === true) setShowPopUp2(!showPopUp2);
    if (showPopUp3 === true) setShowPopUp3(!showPopUp3);
    if (showPopUp4 === true) setShowPopUp4(!showPopUp4);
    if (showPopUp5 === true) setShowPopUp5(!showPopUp5);
    if (showPopUp6 === true) setShowPopUp6(!showPopUp6);
    if (showPopUp7 === true) setShowPopUp7(!showPopUp7);
  };
  return (
    <div className="Project">
      {/*<div className='Projects'>
       <SkillsChart/>
        <div>As a front-end developer, I have a strong foundation in HTML/CSS, which is essential for structuring and styling the content of websites. I am well-versed in JavaScript, the main programming language used for front-end development, and have experience using popular JavaScript frameworks and libraries such as React.</div>
      </div>
  */}
    <ProjectEffect/>
      {/* <div className="projectCat">
        <div className="proj">
          {showPopUp1 && (
            <div className="popups1">
              <div className="popup-contents1">
                <div className="popup-contents">
                  <h1> Data Visualization</h1>
                  <div className="popup-div">
                    <img src={Pop1} className="popimg1" alt="" />
                    <p >
                      I recently worked on a data visualization project that
                      involved loading API data from cable performance into a
                      React page. I used the Recharts library to create bar and
                      line charts to display the data. First, I loaded the API
                      data into the React application using React query. I made
                      a GET request to the API and stored the data in the
                      component's state.
                    </p>
                  </div>
                  <div>
                    <a href="https://glittery-manatee-b5e2bb.netlify.app">Go to site</a>
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                  </div>
                </div>
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
              </div>
            </div>
          )}
          <div className="projectDiv1" id="1" onClick={handleButtonClick1}>
            <img src={Datavis} className="datavis" alt="" />
            Data Visualization
          </div>
          {showPopUp2 && (
            <div className="popups2">
              <div className="popup-contents2">
                <div className="popup-contents">
                  <h1> Team Roster Page</h1>
                  <div className="popup-div">
                    <img src={Pop2} className="popimg2" alt="" />
                    <p>
                      I've built a team roster page of the Brooklyn Nets for BSE Global, the team's parent company and the spa
                      needed to display the bio, stats, and a highlight video
                      for each player. To build the webpage, I used a
                      combination of HTML, Sass, JavaScript, and React. I was given permission to use the team's Api endpoints so that I could fetch player's data and 
                      and render it on the page. Overall, the project
                      required me to have a solid understanding of front-end
                      technologies to create a
                      user-friendly and informative team roster page.
                    </p>
                  </div>
                  <div>
                    <a href="https://fervent-euclid-204f9b.netlify.app">
                      Go to site
                    </a>
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                  </div>
                </div>
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
              </div>
            </div>
          )}
          <div className="projectDiv1" id="2" onClick={handleButtonClick2}>
            <img src={Team} className="team" alt="" />
            Team Roster Page
          </div>
        </div>
        <div className="proj">
          {showPopUp3 && (
            <div className="popups3">
              <div className="popup-contents3">
                <div className="popup-contents">
                  <h1> ReactJS Calculator APP</h1>
                  <div className="popup-div">
                    <img src={Pop3} className="popimg3" alt="" />
                    <p>
                    I've built a calculator app using ReactJS. The goal of this project was to create a functional calculator that could perform basic arithmetic operations, additions, subtractions, multiplications, and divisions. I modeled the calculator after Apple's calculator theme and used react hooks to store the operations.
                    </p>
                  </div>
                  <div>
                    <a href="https://tranquil-chebakia-f7b4b8.netlify.app/">
                      Go to site
                    </a>
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                  </div>
                </div>
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
              </div>
            </div>
          )}
          <div className="projectDiv" id="3" onClick={handleButtonClick3}>
            <img src={Calculator} className="calculator" alt="" />
            ReactJS Calculator APP
          </div>
          {showPopUp4 && (
            <div className="popups4">
              <div className="popup-contents4">
                <div className="popup-contents">
                  <h1> E-commerce page</h1>
                  <div className="popup-div">
                    <img src={Pop4} className="popimg4" alt="" />
                    <p style={{fontSize:"17px", color:"purple"}}>
                      I worked on a landing page for an e-commerce websites that specialized in selling or renting software bots. The design team send me a prototype made from Figma to translante into web components. I built this user interface using ReactJS, TypeScript, and some Javascript libraries like Bootstrap and material UI.
                    </p>
                  </div>
                  <div>
                    <a href="https://festive-hopper-2a0a0b.netlify.app">Go to site</a>
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                  </div>
                </div>
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
              </div>
            </div>
          )}
          <div className="projectDiv1" id="4" onClick={handleButtonClick4}>
            <img src={Ecommerce} className="ecommerce" alt="" />
            E-commerce page
          </div>
          {showPopUp5 && (
            <div className="popups5">
              <div className="popup-contents5">
                <div className="popup-contents">
                  <h1> React to do list</h1>
                  <div className="popup-div">
                  <img src={UC} className="ud" alt=""/>
                  </div>
                  <div>
                    <a href="https://www.w3schools.com">Go to site</a>
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                  </div>
                </div>
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
              </div>
            </div>
          )}
          <div className="projectDiv" id="5" onClick={handleButtonClick5}>
            <img src={Todolist} className="todo" alt="" />
            React to do list
          </div>
        </div>
        <div className="proj proji">
          {showPopUp6 && (
            <div className="popups6">
              <div className="popup-contents6">
                <div className="popup-contents">
                  <h1>Team Landing Page</h1>
                  <div className="popup-div">
                  <img src={UC} className="ud" alt=""/>
                  </div>
                  <div>
                    <a href="https://stupefied-visvesvaraya-9004a9.netlify.app/">Go to site</a>
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                  </div>
                </div>
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
              </div>
            </div>
          )}
          <div className="projectDiv1" id="6" onClick={handleButtonClick6}>
            <img src={Teampage} className="teampage" alt="" />
            Backend
          </div>
          {showPopUp7 && (
            <div className="popups7">
              <div className="popup-contents7">
                <div className="popup-contents">
                  <img src={UC} className="uc" alt=""/>
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                    <hr
                      style={{
                        border: "2px solid purple",
                        marginBottom: "20px",
                      }}
                    />
                  </div>
                </div>
                <span className="close" onClick={handleClose}>
                  &times;
                </span>
              
            </div>
          )}
          <div className="projectDiv1" id="7" onClick={handleButtonClick7}>
            <img src={Backend} className="backend" alt="" />
            Backend
          </div>
        </div>
      </div> */}
    </div>
  );
}
